import { WorldClassProstheticsImg } from '../../../../../images';

export default function WorldClassProsthetics() {
  
  return (
    <div className="relative h-screen ">
      <div className="h-1/2 lg:h-full w-full pt-16 md:pt-20 lg:pt-0 flex flex-col justify-center text-center  lg:w-1/2 lg:text-left ">
        <div className="z-10 px-4 max-w-2xl mx-auto sm:px-8">
          <h1 className="text-center lg:text-left text-primary text-2xl sm:text-3xl lg:text-4xl font-semibold">World-class prosthetics, just a click away</h1>
          <p className="mt-3 text-lg text-gray-500 sm:text-xl md:mt-5 md:max-w-3xl">
            <h2 className="text-center lg:text-left text-xl font-sans text-lpGray my-2">Damages, missing, malaligned or discoloured teeth?</h2>
            <div className='my-2 mx-auto lg:mx-0 lg:my-4 w-32 border border-primary'/>
            <p className="text-center lg:text-left text-gray-500 my-1">Our team of expert dentists, specialists and labs takes advantage of our patented AI technologies and innovations to always ensure you a strong and beautiful rehabilitation.</p>
            <p className="text-center lg:text-left text-gray-500 my-1">Step in to a world of precision and skilled prosthetics.</p>
          </p>
        </div>
        </div>
        <div className="relative w-full h-full lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:h-full z-0">
          <img
            className="absolute inset-0 w-full h-full object-cover"
            src={WorldClassProstheticsImg}
            alt=""
          />
        </div>
    </div>
  )
}
